define('bizzabo/models/Auth',['backbone', 'underscore', 'bizzabo/bzapi', 'bizzabo/consts', 'bizzabo/config', 'bizzabo/models/Global'], function(Backbone, _, BZAPI, Consts, CONFIG, Global) {
    var Auth = Backbone.Model.extend({

        initialize : function() {
            this.set({
                isAuthorized : BZAPI.hasToken()
            });
            this.listenTo(Backbone, 'linkedin-connect-success', this.linkedInSuccess);
            this.listenTo(Backbone, 'linkedin-connect-error', this.linkedInError);
        },

        signOut : function() {
            BZAPI.signOut();
            this.set({
                isAuthorized : BZAPI.hasToken()
            });
            Backbone.trigger(Consts.Notifications.signin.SIGNED_OUT);
        },

        linkedInSuccess: function(data) {
            Global.modelPool.getMe().set('external-ids-linkedin', data.id);
            BZAPI.updateToken('linkedin', data.token, data.tokenSecret);
            this.connectWithLinkedinOptions.success && this.connectWithLinkedinOptions.success();
            this.connectWithLinkedinOptions = {};
        },

        linkedInError: function() {
            Global.modelPool.getMe().unset('external-ids-linkedin');
            this.connectWithLinkedinOptions.error && this.connectWithLinkedinOptions.error();
            this.connectWithLinkedinOptions = {};
        },

        connectWithLinkedin: function(options) {
            this.connectWithLinkedinOptions = options || {};
            var url = [
                CONFIG.DASHBOARD_URL + '/auth/linkedin',
                '?successCallbackURL=' + CONFIG.ORGANIZER_URL + '/linkedinCallbackSuccess.html',
                '&errorCallbackURL=' + CONFIG.ORGANIZER_URL + '/linkedinCallbackError.html'
            ].join('');
            window.open(url, 'LinkedInAuth', 'height=645,width=700,status=yes,toolbar=no,menubar=no,location=no');
        }

    });

    return Auth;

});

